<template>
	<div class="page">

		<!-- 搜索条件表单 -->
		<el-form class="ser_form" size="small"  label-width="100px">
			<el-form-item class="el_form_item" label="货源编号">
				<el-input class="el_input" v-model="form.truck_tord_num" placeholder="货源货源编号" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="上游编号">
				<el-input class="el_input" v-model="form.out_trade_num" placeholder="货源运单编号" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="组别编号">
				<el-input class="el_input" v-model="form.group1_num" placeholder="运单组别编号" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="货主手机">
				<el-input class="el_input" v-model="form.shipper_tel" placeholder="货主手机号搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="货主姓名">
				<el-input class="el_input" v-model="form.shipper_user_name" placeholder="货主姓名搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="货主公司">
				<el-input class="el_input" v-model="form.shipper_company_name" placeholder="货主公司名称搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="司机手机">
				<el-input class="el_input" v-model="form.driver_tel" placeholder="司机手机号搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="司机姓名">
				<el-input class="el_input" v-model="form.driver_name" placeholder="司机姓名搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="车牌号">
				<el-input class="el_input" v-model="form.truck_plate_num" placeholder="车牌号搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="收款人手机">
				<el-input class="el_input" v-model="form.truck_owner_tel" placeholder="收款人手机号搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="收款人姓名">
				<el-input class="el_input" v-model="form.truck_owner_name" placeholder="收款人姓名搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="货物名称">
				<el-input class="el_input" v-model="form.cargo_name" placeholder="货物名称搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="结算方式">
				<el-select class="el_input" v-model="form.settlement_type" clearable>
					<el-option label="不限" value=""></el-option>
					<el-option label="按吨结算" value="1"></el-option>
					<el-option label="按方结算" value="2"></el-option>
					<el-option label="按趟结算" value="3"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item class="el_form_item" label="是否回程">
				<el-select class="el_input" v-model="form.is_need_return" clearable>
					<el-option label="不限" value=""></el-option>
					<el-option label="需要回程" value="1"></el-option>
					<el-option label="不需回程" value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item class="el_form_item" label="车型要求">
				<el-cascader class="el_inner_width" v-model="form.need_truck_type" placeholder="请选择车型" :options="ser_para.truck_type" filterable></el-cascader>
			</el-form-item>
			<el-form-item class="el_form_item" label="装货地">
				<el-cascader class="el_input" v-model="form.case_cities" @change="ser_para_case_cities_change" placeholder="装货地省市区" :options="ser_para.cities" filterable></el-cascader>
			</el-form-item>
			<el-form-item class="el_form_item" label="到货地">
				<el-cascader class="el_input" v-model="form.aim_cities" @change="ser_para_aim_cities_change" placeholder="到货地省市区" :options="ser_para.cities" filterable></el-cascader>
			</el-form-item>
			<el-form-item class="el_form_item">
			</el-form-item>
			<el-form-item class="el_form_item elfrom_item" label="发到时间">
				<div class="block">
				<el-date-picker
					v-model="date_value"
					type="datetimerange"
					:picker-options="pickerOptions"
					range-separator="至"
					start-placeholder="发车日期"
					end-placeholder="到货日期"
					align="right"
					value-format="timestamp"
				>
				</el-date-picker>
				</div>
			</el-form-item>
			<el-form-item class="el_form_item">
			</el-form-item>
			<el-form-item label-width="0">
				<el-button type="primary" @click="page_ser">查询</el-button>
				<el-button type="primary" @click="ser_para_clear">清空条件</el-button>
				<el-button type="primary" @click="tord_export_open">导出搜索结果</el-button>
			</el-form-item>
		</el-form>

		<!-- 表格 -->
		<div class="tab_height">
			<el-table :data="list.data" :border="true" :stripe="true" size="small" height="100%" v-loading="list.loading">
				<el-table-column label="货源编号/组别编号/上游单号" width="195px">
					<template slot-scope="scope">
						<div class="tab_line_item">编号:{{scope.row.truck_tord_num}}</div>
						<div class="tab_line_item">组别:{{scope.row.cargo_info.group1_num?scope.row.cargo_info.group1_num:'无'}}</div>
						<div class="tab_line_item">上游:{{scope.row.cargo_info.out_trade_num?scope.row.cargo_info.out_trade_num:'无'}}</div>
					</template>
				</el-table-column>
				<el-table-column label="装货地信息">
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.cargo_info.case_prov}}/{{scope.row.cargo_info.case_city}}/{{scope.row.cargo_info.case_county}}</div>
						<div class="tab_line_item">{{scope.row.cargo_info.case_other_obj.addr_info?scope.row.cargo_info.case_other_obj.addr_info:'无详细地址'}}</div>
						<div class="tab_line_item">联系人:{{scope.row.cargo_info.case_link_man_text}}/{{scope.row.cargo_info.case_link_tel_text}}</div>
						<div class="tab_line_item">发车时间:{{scope.row.cargo_info.case_other_obj.start_time}}{{(scope.row.cargo_info.case_other_obj.start_time_is_check_text)}}</div>
					</template>
				</el-table-column>
				<el-table-column label="卸货地信息">
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.cargo_info.aim_prov}}/{{scope.row.cargo_info.aim_city}}/{{scope.row.cargo_info.aim_county}}</div>
						<div class="tab_line_item">{{scope.row.cargo_info.aim_other_obj.addr_info?scope.row.cargo_info.aim_other_obj.addr_info:'无详细地址'}}</div>
						<div class="tab_line_item">联系人:{{scope.row.cargo_info.aim_link_man_text}}/{{scope.row.cargo_info.aim_link_tel_text}}</div>
					</template>
				</el-table-column>
				<el-table-column label="名称/重量/体积" width="110px">
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.cargo_info.cargo_name}}/{{scope.row.cargo_info.cargo_type}}</div>
						<div class="tab_line_item">重量:{{scope.row.cargo_info.cargo_weight==0?"未设置":scope.row.cargo_info.cargo_weight+"吨"}}</div>
						<div class="tab_line_item">体积:{{scope.row.cargo_info.cargo_volume==0?"未设置":scope.row.cargo_info.cargo_volume+"方"}}</div>
					</template>
				</el-table-column>
				<el-table-column label="运费/结算方式" width="140px">
					<template slot-scope="scope">
						<div class="tab_line_item">距离:{{scope.row.cargo_info.distance}}KM</div>
						<div class="tab_line_item">运费:{{scope.row.cargo_info.freight_total_text}}</div>
						<div class="tab_line_item">{{scope.row.cargo_info.settlement_type_text}}/{{scope.row.cargo_info.is_need_return_text}}</div>
					</template>
				</el-table-column>
				<el-table-column label="发货时间/货车要求/备注" width="170px">
					<template slot-scope="scope">
						<div class="tab_line_item">发货:{{scope.row.cargo_info.creat_time_text}}</div>
						<div class="tab_line_item">货车:{{scope.row.cargo_info.need_truck_type_text}}</div>
						<div class="tab_line_item">备注:{{scope.row.cargo_info.mark?scope.row.cargo_info.mark:"无"}}</div>
					</template>
				</el-table-column>
				<el-table-column label="货主信息/收款人信息" width="220px">
					<template slot-scope="scope">
						<div class="tab_line_item">货主:{{scope.row.shipper_info.name}}/{{scope.row.shipper_info.tel}}</div>
						<div class="tab_line_item">公司:{{scope.row.shipper_company_info.name}}</div>
						<div class="tab_line_item">指定:{{scope.row.truck_owner_info.name}}/{{scope.row.truck_owner_info.tel}}</div>
						<div class="tab_line_item" v-if="scope.row.truck_plate_num">车牌号:{{scope.row.truck_plate_num}}</div>
					</template>
				</el-table-column>

				<!-- 操作行 -->
				<el-table-column fixed="right" label="操作" width="135px">
					<template slot-scope="scope">
						<el-button @click="to_truck_cargo_info(scope.row.cargo_info,'info')" size="mini" type="text">详情</el-button>
						<el-button @click="to_truck_cargo_info(scope.row.cargo_info,'edit')" size="mini" type="text">编辑</el-button>
						<el-button @click="tord_truck_owner_info(scope.row)" type="text" size="mini">承运方</el-button>
						<el-button @click="voucher_show(scope.row.cargo_info.truck_tord_num)" size="mini" type="text" class="btn_left">凭证</el-button>
						<el-button @click="truck_cargo_del(scope.row)" type="text" size="mini" style="color:red">删除</el-button>
						<el-button @click="get_tord_deal_qrcode(scope.row,1)" type="text" size="mini">二维码</el-button>
						<el-button @click="get_tord_deal_qrcode(scope.row,2)" type="text" class="btn_left" size="mini">app二维码</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 分页 -->
		<el-pagination 
			class="margin-top-xl" 
			@size-change="page_size_change"
			@current-change="page_current_change" 
			:current-page="page.p" 
			:page-sizes="[10, 20, 30, 40]"
			:page-size="page.num" 
			:total="list.total*1"
			layout="total, sizes,prev, pager, next, jumper" 
		>
		</el-pagination>

		<!-- 承运方弹出层 -->
		<el-dialog title="指定承运方" width="450px" :visible.sync="truck_owner.dialog_is_show">
			<el-form label-width="80px" label-position="left">
				<el-form-item label="收款人电话">
					<el-input type="number" @change="truck_owner_ser_open" v-model="truck_owner.form.tel" placeholder="不填表示不指定" clearable>
						<el-button @click="truck_owner_ser" type="success" slot="append">查找</el-button>
					</el-input>
				</el-form-item>
				<el-form-item label="收款人信息">
					<el-input v-model="truck_owner.form.name" :disabled="true" clearable></el-input>
				</el-form-item>
				<div style="text-align:center">
					<el-button type="primary" @click="truck_owner_sub">指定收款人</el-button>
					<el-button type="danger" @click="truck_owner_clear">撤销指定</el-button>
				</div>
			</el-form>
		</el-dialog>

		<!-- 凭证界面 -->
		<voucher :truck_tord_num="voucher.truck_tord_num" :is_show="voucher.is_show"></voucher>

		<!-- 凭证界面 -->
		<qrcodeImg 
			:src="qrcode.src" 
			:is_show="qrcode.is_show"
			:bl_data="qrcode.bl_data"
		></qrcodeImg>
		<!-- 导出搜索结果 -->
		<serRelExport 
			:is_show="tord_export.is_show" 
			:rull="tord_export.rull" 
			@close="tord_export_close" 
		></serRelExport>
	</div>
</template>

<script>
	import {regionData,CodeToText} from 'element-china-area-data'
	import truck_type_handle from '@/my/_truck_type_handle.js'
	import voucher from '../../voucher/voucher_before_end.vue'
	import qrcodeImg from '@/components/qrcode.vue'
	import serRelExport from './ser_rel_export.vue'
	export default {
		components:{
			voucher,
			qrcodeImg,
			serRelExport
		},
		data() {
			return {

				//指定收款人
				truck_owner:{
					dialog_is_show:false,//模态框开启状态
					truck_tord_num:'',//货源编号(操作行)
					old_truck_owner_tel:'',//旧的被指定的收款人(操作行)
					form:{
						tel:'',//收款人电话
						name:'',//收款人姓名
						user_num:''//收款人编号
					}
				},
				date_value:'',
				pickerOptions: {
					shortcuts: [
					{
						text: "最近一周",
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "最近一个月",
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "最近三个月",
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit("pick", [start, end]);
						},
					},
					],
				},
				//搜索条件参数
				ser_para:{
					cities:regionData,//省市区数据
					truck_type:[],//货车类型
				},

				//搜索条件
				form: {				
					truck_tord_num:'',//货源编号
					group1_num:'',//组别编号
					out_trade_num:'',//上游运单编号
					settlement_type:'',//结算方式
					is_need_return:'',//是否回程
					shipper_tel:'',//货主手机号
					shipper_user_name:'',//货主姓名
					shipper_company_name:'',//货主公司名称
					truck_owner_tel:'',//收款人手机号
					truck_owner_name:'',//收款人姓名
					cargo_name:'',//货物名称
					case_prov:'',//装货地省份
					case_city:'',//装货地城市
					case_county:'',//装货地县区
					aim_prov:'',//到货地省份
					aim_city:'',//到货地城市
					aim_county:'',//到货地县区

					case_cities:null,//装货地省市县
					aim_cities:null,//到货地省市县
					driver_tel:'',//司机手机号
					driver_name:'',//司机姓名
					truck_plate_num:'',//车牌号
					start_time_start:0,
					arrived_time_end:0,
				},

				//表格数据
				list: {
					loading: false,//loading特效
					data: [],//列表数据
					total: 0,//列表总记录数
				},

				//页码信息
				page: {
					need_num:1,
					num: 10,
					p: 1,
				},

				//凭证相关
				voucher:{
					is_show:0,
					truck_tord_num:''
				},

				//货源二维码
				qrcode:{
					is_show:0,
					src:'',
					bl_data:{}
				},
				//导出搜索结果界面
				tord_export:{
					is_show:0,
					rull:{}
				},
			}
		},
		created() {
			
			//获取可用搜索参数
			this.get_ser_para()

			//读取货源
			this.get_page_data()
		},
		methods: {
			tord_export_open(){
				//置入条件
				this.tord_export.rull=this.form

				//打开界面
				this.tord_export.is_show++
			},
			tord_export_close(){//关闭界面

				//关闭界面
				this.tord_export.is_show=0
			},
			//生成线路二维码
			get_tord_deal_qrcode(item,code_type){

				//调接口
				this.$my.net.req({
					data:{
						mod:'truck_tord_real_time',
						ctr:'get_tord_deal_qrcode',
						truck_tord_num:item.truck_tord_num,
						code_type
					},
					callback:(data)=>{

						//置入src
						this.qrcode.src=data.img

						//拼接底部字符串
						// let under_text=`${item.cargo_info.case_city}${item.cargo_info.case_county}--${item.cargo_info.aim_city}${item.cargo_info.aim_county}`;
						// if(item.mark)under_text+=` (${item.mark})`
						// this.qrcode.under_text=under_text
						this.qrcode.bl_data=item.cargo_info
					
						//打开
						this.qrcode.is_show++
					}
				});
			},
			
			//凭证相关操作
			voucher_show(truck_tord_num){//显示凭证
				this.voucher.is_show++;
				this.voucher.truck_tord_num=truck_tord_num
			},

			//提交承运方信息
			truck_owner_sub(){
				
				//校验
				if(!this.truck_owner.form.user_num){
					this.$my.other.msg({
						type:'warning',
						str:'没有输入收款人信息,提示:输入电话号码后要点击"查找"按钮'
					});
					return;
				}
				if(this.truck_owner.form.tel==this.truck_owner.old_truck_owner_tel){
					this.truck_owner.dialog_is_show=false;
					return;
				}

				//提交
				this.$my.net.req({
					data:{
						mod:'truck_tord_real_time',
						ctr:'truck_cargo_set_truck_owner_admin',
						truck_tord_num:this.truck_owner.truck_tord_num,
						truck_owner_tel:this.truck_owner.form.tel
					},
					callback:(data)=>{

						//刷新数据
						this.get_page_data()
						
						//关闭弹出层
						this.truck_owner.dialog_is_show=false;

						//反馈数据
						this.$my.other.msg({
							type:'success',
							str:'操作成功'
						});
					}
				})
			},

			//撤销指定
			truck_owner_clear(){
				this.$my.other.confirm({
					content:'点击确定撤销指定此货源的收款人,撤销之后此货源会重新进入货源池',
					confirm:()=>{
						this.$my.net.req({
							data:{
								mod:'truck_tord_real_time',
								ctr:'truck_cargo_revoke_by_admin',
								truck_tord_num:this.truck_owner.truck_tord_num,
							},
							callback:(data)=>{

								//关闭弹出层
								this.truck_owner.dialog_is_show=false;

								//刷新页面
								this.get_page_data();

								//报告结果
								this.$my.other.msg({
									type:'success',
									str:'撤销成功'
								});
							}
						})
					}
				});
			},

			//电话号码输入事件,用于打开服务器搜索权限
			truck_owner_ser_open(){
				this.truck_owner.form.need_read=true;
			},

			//搜索承运方信息
			truck_owner_ser(){

				//是否输入电话号码
				if(!this.$my.check.is_tel(this.truck_owner.form.tel)){
					this.$my.other.msg({
						type:'warning',
						str:'电话号码格式有误'
					});
					return;
				}
				
				//是否不需要读取
				if(!this.truck_owner.form.need_read){
					return;
				}

				//读取
				this.$my.net.req({
					data:{
						mod:'truck',
						ctr:'truck_owner_info',
						truck_owner_tel:this.truck_owner.form.tel,
					},
					callback:(data)=>{

						if(data.name=='未实名'){
							this.$my.other.msg({
								type:"warning",
								str:'此用户未完成实名认证'
							});
							return;
						}
						
						//写入数据
						this.truck_owner.form.name=data.name
						this.truck_owner.form.user_num=data.user_num
						this.truck_owner.form.need_read=false
					}
				})
			},

			//承运方信息
			tord_truck_owner_info(item){

				//打开模态框
				this.truck_owner.dialog_is_show=true;

				//对象初始化
				this.truck_owner.truck_tord_num=item.truck_tord_num
				this.truck_owner.old_truck_owner_tel='';
				this.truck_owner.form.tel='';
				this.truck_owner.form.name=''
				this.truck_owner.form.user_num=''
				this.truck_owner.form.need_read=false;

				//置入数据
				if(item.truck_owner){
					this.truck_owner.old_truck_owner_tel=item.truck_owner.tel
					this.truck_owner.form.tel=item.truck_owner.tel
					this.truck_owner.form.name=item.truck_owner.name
					this.truck_owner.form.user_num=item.truck_owner.user_num
					this.truck_owner.form.need_read=false;
				}else{
					this.get_tord_truck_owner_info(item);
				}
			},

			//去服务器上读取承运方信息并缓存
			get_tord_truck_owner_info(item){
				this.$my.net.req({
					data:{
						mod:'truck_tord_real_time',
						ctr:'get_tord_and_truck_owner_by_cargo_num',
						truck_tord_num:item.truck_tord_num
					},
					callback:(data)=>{

						if(!data.truck_owner){
							return;
						}

						//收款人数据
						this.truck_owner.old_truck_owner_tel=data.truck_owner.tel
						this.truck_owner.form.tel=data.truck_owner.tel
						this.truck_owner.form.name=data.truck_owner.name
						this.truck_owner.form.user_num=data.truck_owner.user_num
						this.truck_owner.form.need_read=false
						
						//缓存数据
						item.truck_owner={...data.truck_owner}
					}
				})
			},

			//前往货源详情
			to_truck_cargo_info(item,act){
				
				//跳转
				this.$router.push({
					path:'/pages/transit_real_time/cargo_edit_admin',
					query:{
						act:act,
						truck_tord_num:item.truck_tord_num,
						come_from:'/pages/transit_real_time/tord_deal'
					}
				});
			},

			//删除货源
			truck_cargo_del(item){
				
				if(item.status==2){
					this.$my.other.msg({
						type:'warning',
						str:'此运单已经指定收款人,不能删除'
					});
					return
				}

				//询问
				this.$my.other.confirm({
					content:"确定删除货源",
					confirm:()=>{

						//调接口
						this.$my.net.req({
							data:{
								mod:'truck_tord_real_time',
								ctr:'cargo_del_admin',
								truck_tord_num:item.truck_tord_num
							},
							callback:(data)=>{

								//刷新本页面数据
								this.get_page_data();
							}
						})
					}
				})
			},

			//发货地省市县选择器
			ser_para_case_cities_change(event){
				this.form.case_prov=CodeToText[event[0]];
				this.form.case_city=CodeToText[event[1]];
				this.form.case_county=CodeToText[event[2]];
			},

			//到货地省市县选择器
			ser_para_aim_cities_change(event){
				this.form.aim_prov=CodeToText[event[0]];
				this.form.aim_city=CodeToText[event[1]];
				this.form.aim_county=CodeToText[event[2]];
			},

			//清空查询条件
			ser_para_clear(){
				this.form={
					truck_tord_num:'',//货源编号
					group1_num:'',//组别编号
					out_trade_num:'',//上游运单编号
					settlement_type:'',//结算方式
					is_need_return:'',//是否回程
					shipper_tel:'',//货主手机号
					shipper_user_name:'',//货主姓名
					shipper_company_name:'',//货主公司名称
					truck_owner_tel:'',//收款人手机号
					truck_owner_name:'',//收款人姓名
					cargo_name:'',//货物名称
					case_prov:'',//装货地省份
					case_city:'',//装货地城市
					case_county:'',//装货地县区
					aim_prov:'',//到货地省份
					aim_city:'',//到货地城市
					aim_county:'',//到货地县区

					case_cities:null,//装货地省市县
					aim_cities:null,//到货地省市县
					driver_tel:'',//司机手机号
					driver_name:'',//司机姓名
					truck_plate_num:'',//车牌号
					start_time_start:0,
					arrived_time_end:0,
				}
				this.get_page_data()
			},

			//搜索
			page_ser(){
				if (this.date_value) {
					this.form.start_time_start = parseInt(this.date_value[0] / 1000);
					this.form.arrived_time_end= parseInt(this.date_value[1] / 1000);
				} else {
					this.form.start_time_start = "";
					this.form.arrived_time_end = "";
				}
				//读取第一页
				this.page.p=1

				//读取
				this.get_page_data()
			},

			//页宽变化
			page_size_change(num){

				//置入页码
				this.page.num=num

				//读取
				this.get_page_data()
			},

			//页码变化
			page_current_change(p){
				
				//置入页码
				this.page.p=p

				//读取
				this.get_page_data()
			},

			//获取货源列表
			get_page_data(){

				//加载中...
				if(this.list.loading){
					return;
				}

				//置为加载中
				this.list.loading=true;

				//读取数据
				this.$my.net.req({
					data:{
						mod:'truck_tord_real_time',
						ctr:'tord_deal_list_admin',
						...this.form,
						...this.page
					},
					callback:(data)=>{

						//加载完毕
						this.list.loading=false

						//总数
						this.list.total=data.max

						//预处理
						for(let item of data.list){

							//货源详情
							var cargo_info=item.cargo_info

							//发货时间
							cargo_info.creat_time_text=this.$my.other.totime(cargo_info.creat_time);

							//装货联系人
							if(cargo_info.case_link_man){
								cargo_info.case_link_man_text=cargo_info.case_link_man;
							}else cargo_info.case_link_man_text="无";

							//装货联系电话
							if(cargo_info.case_link_tel){
								cargo_info.case_link_tel_text=cargo_info.case_link_tel;
							}else cargo_info.case_link_tel_text="无";

							//卸货联系人
							if(cargo_info.aim_link_man){
								cargo_info.aim_link_man_text=cargo_info.aim_link_man;
							}else cargo_info.aim_link_man_text="无";

							//卸货联系电话
							if(cargo_info.aim_link_tel){
								cargo_info.aim_link_tel_text=cargo_info.aim_link_tel;
							}else cargo_info.aim_link_tel_text="无";

							/* 装货地其他数据(json) */
							cargo_info.case_other_obj=JSON.parse(cargo_info.case_other);

							//装货时间
							if(!cargo_info.case_other_obj.case_time_start && cargo_info.case_other_obj.case_time_end){//只有止点

								cargo_info.case_other_obj.case_date=this.$my.other.todate(cargo_info.case_other_obj.case_time_end)+"以前";

							}else if(cargo_info.case_other_obj.case_time_start && !cargo_info.case_other_obj.case_time_end){//只有起点

								cargo_info.case_other_obj.case_date=this.$my.other.todate(cargo_info.case_other_obj.case_time_start)+"以后";

							}else if(cargo_info.case_other_obj.case_time_start && cargo_info.case_other_obj.case_time_end){//都有

								cargo_info.case_other_obj.case_date=this.$my.other.todate(cargo_info.case_other_obj.case_time_start)+" ~ "+this.$my.other.todate(cargo_info.case_other_obj.case_time_end);

							}else if(!cargo_info.case_other_obj.case_time_start && !cargo_info.case_other_obj.case_time_end){//都没有

								cargo_info.case_other_obj.case_date="未设置";
							}

							//发车时间
							if(!cargo_info.case_other_obj.start_time_1 && cargo_info.case_other_obj.start_time_2){//只有止点

								cargo_info.case_other_obj.start_time=this.$my.other.todate(cargo_info.case_other_obj.start_time_2)+"以前";

							}else if(cargo_info.case_other_obj.start_time_1 && !cargo_info.case_other_obj.start_time_2){//只有起点

								cargo_info.case_other_obj.start_time=this.$my.other.todate(cargo_info.case_other_obj.start_time_1)+"以后";

							}else if(cargo_info.case_other_obj.start_time_1 && cargo_info.case_other_obj.start_time_2){//都有

								cargo_info.case_other_obj.start_time=this.$my.other.todate(cargo_info.case_other_obj.start_time_1)+" ~ "+this.$my.other.todate(cargo_info.case_other_obj.start_time_2);

							}else if(!cargo_info.case_other_obj.start_time_1 && !cargo_info.case_other_obj.start_time_2){//都没有
								
								cargo_info.case_other_obj.start_time="未设置";
							}

							//发车时间是否强制校验
							switch(cargo_info.case_other_obj.start_time_is_check){
								case '1':cargo_info.case_other_obj.start_time_is_check_text="(强制)";break;
								case '2':cargo_info.case_other_obj.start_time_is_check_text="(不强制)";break;
							}
							if(cargo_info.case_other_obj.start_time=="未设置"){//如果未设置发车时间,则不存在强制不强制
								cargo_info.case_other_obj.start_time_is_check_text=""
							}

							/* 卸货地其他数据(json) */
							cargo_info.aim_other_obj=JSON.parse(cargo_info.aim_other);

							//卸货时间
							if(!cargo_info.aim_other_obj.aim_time_start && cargo_info.aim_other_obj.aim_time_end){//只有止点

								cargo_info.aim_other_obj.aim_date=this.$my.other.todate(cargo_info.aim_other_obj.aim_time_end)+"以前";

							}else if(cargo_info.aim_other_obj.aim_time_start && !cargo_info.aim_other_obj.aim_time_end){//只有起点

								cargo_info.aim_other_obj.aim_date=this.$my.other.todate(cargo_info.aim_other_obj.aim_time_start)+"以后";

							}else if(cargo_info.aim_other_obj.aim_time_start && cargo_info.aim_other_obj.aim_time_end){//都有

								cargo_info.aim_other_obj.aim_date=this.$my.other.todate(cargo_info.aim_other_obj.aim_time_start)+" ~ "+this.$my.other.todate(cargo_info.aim_other_obj.aim_time_end);

							}else if(!cargo_info.aim_other_obj.aim_time_start && !cargo_info.aim_other_obj.aim_time_end){//都没有
								
								cargo_info.aim_other_obj.aim_date="未设置";
							}
							
							//结算方式
							switch(cargo_info.settlement_type){
								case '1':cargo_info.settlement_type_text="按吨数";break;
								case '2':cargo_info.settlement_type_text="按方数";break;
								case '3':cargo_info.settlement_type_text="按趟";break;
							}
							
							//是否回程
							switch(cargo_info.is_need_return){
								case '1':cargo_info.is_need_return_text="需要回程";break;
								case '2':cargo_info.is_need_return_text="不需要回程";break;
							}

							//运费
							if(cargo_info.freight_total>0){
								
								cargo_info.freight_total_text=cargo_info.freight_total+" 元";

							}else cargo_info.freight_total_text="未设置";

							//货车类型
							if(cargo_info.need_truck_type){
								cargo_info.need_truck_type_text=cargo_info.need_truck_type+' / '+cargo_info.need_truck_type2
							}else cargo_info.need_truck_type_text="无要求"

							//运输距离
							if(cargo_info.distance>0){
								cargo_info.distance_text=cargo_info.distance+'公里'
							}else item.distance_text="未知"
						}

						//渲染
						this.list.data=data.list
					}
				})
			},

			//获取可用搜索参数
			get_ser_para(){

				//尝试从缓存中取出
				let ser_para=this.$my.cache.get('cargo_creat_page_creat_para');

				//如果取出成功
				if(ser_para){
					// this.ser_para.cargo_type=[...ser_para.cargo_type]
					this.ser_para.truck_type=[...ser_para.truck_type]
					return
				}

				//如果取出失败,去服务器读取
				this.$my.net.req({
					data:{
						mod:'truck_tord_real_time',
						ctr:'cargo_creat_para'
					},
					callback:(data)=>{

						//格式化车型数据
						let truck_type=truck_type_handle.for_el_cascader(data.truck_type);
						
						//缓存之
						this.$my.cache.set({
							cargo_creat_page_creat_para:{
								truck_type:truck_type,
								cargo_type:data.cargo_type
							}
						});

						//置入
						this.ser_para.cargo_type=[...data.cargo_type]
						this.ser_para.truck_type=[...truck_type]
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page{
		background-color: #fff;
		padding: 20px;
		border-radius: 10px;
		height: calc(100% - 40px);
		overflow: auto;
	}
	.ser_form{
		display: flex;
		align-items: flex-end;
		flex-wrap: wrap;
	}
	.tab_height{
		height:calc(100% - 190px);
	}
	.el_form_item{
		width: 16.6672%;
	}
	.el_input{
		width:94%
	}
	.btn_left{
		margin: 0;
	}
</style>